export default function decodeHTMLEntities(input) {
    if(!input || typeof input !== 'string') {
        return null;
    }

    let element = document.createElement('div');

    // strip script/html tags
    input = input.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
    input = input.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
    element.innerHTML = input;
    input = element.textContent;
    element.textContent = '';
    element = null;

    return input;
}